import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import apiService from '../services/apiService';

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      isAuthenticated: false,
      loading: false,
      error: null,

      login: async (email, password) => {
        set({ loading: true, error: null });
        try {
          const userData = await apiService.authenticateEmployee(email, password);
          set({ 
            user: userData.data,
            isAuthenticated: true, 
            loading: false,
            error: null 
          });
          
          return { success: true };
        } catch (error) {
          set({ 
            loading: false, 
            error: error.message,
            isAuthenticated: false,
            user: null 
          });
          return { success: false, error: error.message };
        }
      },

      logout: () => {
        set({ 
          user: null, 
          isAuthenticated: false, 
          error: null 
        });
      },

      clearError: () => {
        set({ error: null });
      },

       // 🔑 NEW
      updateUser: (newUserData) => {
        set((state) => ({
          user: { ...state.user, ...newUserData }
        }));
      },
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ 
        user: state.user, 
        isAuthenticated: state.isAuthenticated 
      }),
    }
  )
);

export { useAuthStore };
